import { render, staticRenderFns } from "./ShowAnswer.vue?vue&type=template&id=23c5fcdc"
import script from "./ShowAnswer.vue?vue&type=script&lang=js"
export * from "./ShowAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports